var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.576,
    height: 18.13,
    viewBox: "0 0 18.576 18.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Print_icon",
    "data-name": "Print icon",
    d: "M369.147-432.869A2.149,2.149,0,0,1,367-435.016v-3.5a2.149,2.149,0,0,1,2.146-2.147h.976V-448.3a2.687,2.687,0,0,1,.791-1.911,2.7,2.7,0,0,1,1.911-.791h3.791a2.673,2.673,0,0,1,1.911.792l3.243,3.242a2.705,2.705,0,0,1,.787,1.912v4.4h.872a2.149,2.149,0,0,1,2.147,2.147v3.5a2.149,2.149,0,0,1-2.147,2.146Zm-.836-5.642v3.5a.837.837,0,0,0,.836.836h14.282a.837.837,0,0,0,.836-.836v-3.5a.838.838,0,0,0-.836-.837H369.147A.838.838,0,0,0,368.31-438.511Zm3.605-10.7a1.3,1.3,0,0,0-.377.909v7.639h9.6v-4.4a1.046,1.046,0,0,0-.007-.118h-1.706a2.684,2.684,0,0,1-1.91-.791,2.7,2.7,0,0,1-.791-1.91v-1.7c-.039,0-.076-.006-.114-.006h-3.788A1.277,1.277,0,0,0,371.915-449.207Zm6.231,1.333a1.276,1.276,0,0,0,.377.908,1.3,1.3,0,0,0,.908.377h.707l-1.992-1.992Z",
    transform: "translate(-367 451)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintimg);
export default __webpack_public_path__ + "static/media/Printimg.ef1a4c04b7856d1323fdda86d6a34f58.svg";
export { ForwardRef as ReactComponent };